






















































































































import {Vue, Component} from 'vue-property-decorator'
import {Button} from 'mand-mobile'
import analyze from 'guardian-liveness-detection-lib/src/libs/analyze'
import 'vue-loading-overlay/dist/vue-loading.css'
import * as Sentry from '@sentry/browser'

// flow
import store from '@/store'
// import { getUIConfig } from '@/lib/photograph-flow/flow/configSkin'
import {takePhotoHandler} from '@/lib/photograph-flow/flow/takePhoto'
import {loadHandler} from '@/lib/photograph-flow/flow/load'
import {checkHandler, CheckResultType} from '@/lib/photograph-flow/flow/check'
import {resolveHandler} from '@/lib/photograph-flow/flow/resolve'
import {analyzeImages} from '@/lib/photograph-flow/lib/resolveImage'
import {uploadHandlerV3} from '@/lib/photograph-flow/flow/upload'
import { cutString, getQueryString, sendMessage, appSource } from '@/lib/common-util'
import DialogPrompt from '@/views/common/DialogPrompt.vue'

// event tracking
import { getReport, sendReport } from '@/lib/imageReport'
import AES from '@/lib/aes'
import EXIF from 'exif-js'
import { Report, ReportType } from '@/libs/report'
// import { imageInvalidTokenCheckAndHandlerV2 } from '@/lib/invalidTokenCheckAndHandler'

// tslint:disable-next-line
const Loading = require('vue-loading-overlay')
// Maximum acceptable image
const MAX_SIZE = 5 * 1024 * 1024 // byte  s

interface IFileObj {
  file: File
  image?: HTMLImageElement
}

interface IResolveResult {
  file?: Blob[],
  imageFileFullName?: string,
  imageOrigFormat?: string,
  imageOrigSize?: number,
  imageOrigWidth?: number,
  imageOrigHeight?: number,
  isResolved?: boolean,
  resolveTime?: number,
  imageResolvedFormat?: string,
  imageResolvedSize?: number,
  imageResolvedWidth?: number
  imageResolvedHeight?: number
  errorMsg?: string,
}

interface IUploadResult {
  code?: string,
  message?: string,
  uploadTime?: number,
  transactionId?: string,
  score?: number,
  errorMsg?: string,
  tryCount?: number,
  returnUrl?: string,
  failedReturnUrl?: string; // failedReturnUrl是从接口中返回的
}

@Component({components: {[Button.name]: Button, Loading, DialogPrompt}})
export default class Home extends Vue {
  bizToken: any = null
  failedCode: string = ''
  failedMessage: any = null
  isAllowUpload: boolean = false
  preparing: boolean = false
  loading: boolean = false
  resolveFile: Blob[] = []
  compressedFile: any = null
  resolveResult: null | IResolveResult = null
  uploadResult: null | IUploadResult = null
  imageBasicInfo: any = null
  imageMetaData: any = null
  eventTimestamp: number = -1
  takePhotoTimestamp: number = -1

  mobileTipsPage: any = {}
  mobileLoadingPage: any = {}
  mobileErrorDialog: any = {}
  titleTexta: any = 'Liveness Detection'

  // dialog
  formatNotSupportHint: boolean = false
  resolveFailedHint: boolean = false
  unresolvedVideoSizeTooBigHint: boolean = false

  mobileResultPageShow: number = 1

  isLoading: boolean = true
  isLoadingTime: any = null

  async startHandler() {
    Report.create(ReportType.ClickStart).send()

    try {
      // step1 - take photo
      this.eventTimestamp = new Date().getTime()
      // console.log('take photo......')
      const file = await takePhotoHandler()
      // console.log('file', file)

      Report.create(ReportType.TakePhoto).send()

      // step2 - load
      // console.log('load......')
      this.preparing = true
      const loadImage = await loadHandler(file)
      this.preparing = false
      // console.log('loadImage', loadImage)

      Report.create(ReportType.LoadImage).send()

      // step3 - check
      this.loading = true
      this.takePhotoTimestamp = new Date().getTime()
      const checkFile = await checkHandler(loadImage)
      // console.log('checkFile', checkFile, checkFile.type, loadImage.file, loadImage.image)
      this.imageMetaData = analyze(loadImage.file, loadImage.image as any)
      // console.log(this.imageMetaData, checkFile.type)
      switch (checkFile.type) {
        case CheckResultType.FILE_SUFFIX_NOT_MATCH:
          // console.log('resolve FILE_SUFFIX_NOT_MATCH')
          this.formatNotSupportHint = true
          this.failedCode = 'UNACCEPTED_SUFFIX'
          this.failedMessage = this.$t(`home.formatNotSupport`)
          this.sendReportPreCheck(false, 'UNACCEPTED_SUFFIX', checkFile.fileObj, false)
          // return
          break
        case CheckResultType.NO_IMAGE_ERROR:
          // console.log('resolve NO_IMAGE_ERROR')
          this.resolveFailedHint = true
          this.failedCode = 'NONSUPPORT_DEVICE'
          this.failedMessage = this.$t(`home.resolveFailed`)
          Sentry.captureException('image error')
          this.sendReportPreCheck(false, 'NONSUPPORT_DEVICE', checkFile.fileObj, false)
          return
      }


      // step4 - resolve  checkFile.type === 'NEED_RESOLVE'
      // console.log('compressing......')
      try {
        const resolveStartTime = new Date().getTime()
        this.resolveFile = await resolveHandler(
          checkFile.fileObj.image as HTMLImageElement, checkFile.fileObj.file.size,
        )
        // console.log('resolve file 888888888', this.resolveFile)
        this.compressedFile = analyzeImages(this.resolveFile)
        this.resolveResult = {
          imageFileFullName: checkFile.fileObj.file.name,
          imageOrigFormat: this.imageMetaData.fileSuffix,
          imageOrigSize: checkFile.fileObj.file.size,
          imageOrigWidth: this.imageMetaData ? this.imageMetaData.width : 0,
          imageOrigHeight: this.imageMetaData ? this.imageMetaData.height : 0,
          isResolved: this.resolveFile instanceof Array ? true : false,
          resolveTime: new Date().getTime() - resolveStartTime,
          imageResolvedFormat: this.compressedFile.dataType === 'image/webp' ? 'webp' : 'jpeg',
          imageResolvedSize: this.compressedFile.size * 1024,
          imageResolvedWidth: this.compressedFile.resolvedWidth,
          imageResolvedHeight: this.compressedFile.resolvedHeight,
        }
        // console.log('this.resolveResult', this.resolveResult)
      } catch (error) {
        // console.log('resolve failed', error)
        this.resolveFailedHint = true
        this.failedCode = 'RESOLVE_IMAGE_FAILED'
        this.failedMessage = this.$t(`home.resolveFailed`)
        Sentry.captureException(error)
        this.sendReportResolve(false, (error as any).message, this.resolveResult || {}, false)
        return
      }


      // step5 - upload
      await this.overtakeMaximumSizeReject(this.compressedFile.size * 1024)

      const resolveFileA = this.resolveFile[0]
      // console.log('encryptAes:', resolveFileA)
      const encryptAesStr: any = await this.fileBaseAESHandle(resolveFileA, this.compressedFile)
      // console.log('encryptAes:', encryptAesStr)
      await this.uploadStep({ images: this.resolveFile }, encryptAesStr)
      // await this.uploadStep({ images: this.resolveFile })
    } catch (error) {
      console.error('input_load_check failed', error)
      // this.unresolvedVideoSizeTooBigHint = true
      // this.failedCode = 'NONSUPPORT_NETWORK'
      // this.failedMessage = this.$t(`home.unresolvedVideoSizeTooBig`)
      // Sentry.captureException(error)
      // this.sendReportResolve(false, (error as any).message, this.resolveResult || {}, false)
      return
    } finally {
      this.loading = false
    }
  }
  async isConfigCon() {
    try {
      // const data = await getUIConfig({
      //   locale: this.$root.$i18n.locale || 'en',
      //   token: this.bizToken,
      //   signatureId: '',
      // })
      // if (data.code === 'SUCCESS') {
      //   const resultSkinCon = data.data || {}
      let resultSkinCon: any = sessionStorage.getItem('UIConfigObj') || false
      if (!resultSkinCon) {
        resultSkinCon = '{}'
        this.isLoadingTime = setTimeout(() => {
          this.isLoading = false
        }, 10000)
        return
      }
      clearTimeout(this.isLoadingTime)
      resultSkinCon = JSON.parse(resultSkinCon) || {}
      this.titleTexta = (resultSkinCon.titleText && resultSkinCon.titleText.length > 0) ? resultSkinCon.titleText : 'Liveness Detection'
      localStorage.setItem('titleText', this.titleTexta)
      sessionStorage.setItem('resultTextCon', JSON.stringify(resultSkinCon))
      this.mobileTipsPage = resultSkinCon.mobileTipsPage || {}

      if (resultSkinCon.mobileResultPage && resultSkinCon.mobileResultPage.isShow === false) {
        this.mobileResultPageShow = 0
      } else {
        this.mobileResultPageShow = 1
      }

      this.mobileLoadingPage = resultSkinCon.mobileLoadingPage || {}
      this.mobileErrorDialog = resultSkinCon.mobileErrorDialog || {}
      this.isLoading = false
      // }
    } catch (error) {
      console.log(error)
    }
  }
  fileEXIFHandle(file: any) {
    return new Promise((resolve, reject) => {
      EXIF.getData(file as any, async () => {
        const allEXIFTags = EXIF.getAllTags(file)
        // console.log('allEXIFTags:', allEXIFTags)
        resolve(allEXIFTags)
      })
    })
  }
  fileBaseAESHandle(file: any, compressedFile: any) {
    return new Promise((resolve, reject) => {
      // 转码base64
      const reader = new FileReader()
      const resolveFileA = file
      reader.readAsDataURL(resolveFileA as any)
      reader.onload = (e: any) => {
        let fileComplete = e.target.result
        // console.log('fileComplete: ', fileComplete)
        fileComplete = fileComplete.replace(/^data:image\/\w+;base64,/, '')
        const originalTimer = document.getElementsByTagName('body')[0].getAttribute('timer') || ''
        let originalStamp = null
        if (originalTimer && originalTimer.length > 0) {
          const reg = new RegExp(':', 'g')
          const dateStr = originalTimer.split(' ')[0].replace(reg, '-') || ''
          const dateBeforeAfter = originalTimer.split(' ')[1] || ''
          const dataProcessing = `${dateStr} ${dateBeforeAfter}`
          originalStamp = Date.parse(dataProcessing)
        }
        const platformStr = appSource()
        const encryptData = {
          image: fileComplete,
          imageCreateTime: originalStamp,
          requestTimeMills: this.takePhotoTimestamp,
          takePhotoClickTime: this.eventTimestamp,
          suffix: compressedFile && compressedFile.dataType === 'image/webp' ? '.webp' : '.jpeg',
          platform: platformStr,
        }
        if (platformStr === 'iOS') {
          encryptData.platform = platformStr
        }
        const encryptDataStr = JSON.stringify(encryptData)
        const encryptAesStr = AES.encrypt(encryptDataStr)

        // const decryptAes = AES.decrypt(encryptAesStr, '2012bdeec037d05a')da92e33a96cd32a1
        // console.log('dddddddd', decryptAes)
        // console.log('dddddddd', {imageCreateTime: originalStamp, requestTimeMills: new Date().getTime(), suffix: compressedFile && compressedFile.dataType === 'image/webp' ? '.webp' : '.jpeg', platform: platformStr})
        resolve(encryptAesStr)
      }
    })
  }
  async uploadStep(payload: {file?: File; images?: Blob[]}, encryptData: string) {
    try {
      const uploadStartTime = new Date().getTime()
      const uploadReturnData = await uploadHandlerV3(encryptData, this.bizToken)
      const uploadResult = {
        code: uploadReturnData.code,
        message: uploadReturnData.message,
        transactionId: uploadReturnData.transactionId,
        score: uploadReturnData.data ? uploadReturnData.data.score : 0,
        uploadTime: new Date().getTime() - uploadStartTime,
        tryCount: uploadReturnData.data ? uploadReturnData.data.tryCount : 0,
        returnUrl: uploadReturnData.data ? uploadReturnData.data.returnUrl : '',
        failedReturnUrl: uploadReturnData.data ? uploadReturnData.data.failedReturnUrl : '',
      }
      this.uploadResult = uploadResult


      this.imageBasicInfo = {
        imageFileFullName: payload.file ? payload.file.name : '',
        imageOrigFormat: this.imageMetaData ? this.imageMetaData.fileSuffix : '',
        imageOrigSize: payload.file ? payload.file.size : 0,
        imageOrigWidth: this.imageMetaData ? this.imageMetaData.width : 0,
        imageOrigHeight: this.imageMetaData ? this.imageMetaData.height : 0,
        isResolved: false,
      }

      // if is invalid token, direct to result page
      // if (imageInvalidTokenCheckAndHandlerV2(uploadResult.code as string)) {
      //   return
      // }
      // console.log('uploadReturnData.code', uploadReturnData.code)
      if (uploadReturnData.code === 'SUCCESS') {
        this.sendReportUpload(true, uploadResult.message, this.resolveResult || this.imageBasicInfo, uploadResult, true)
      } else {
        this.sendReportUpload(false, uploadResult.message, this.resolveResult || this.imageBasicInfo, uploadResult, true)
      }

      // console.log('upload success')
      this.pageJumpHandler(uploadReturnData)
    } catch (error) {
      // console.error('upload failed', error)
      this.resolveFailedHint = true
      this.failedCode = 'NONSUPPORT_DEVICE'
      this.failedMessage = this.$t(`home.resolveFailed`)
      Sentry.captureException(error)
      this.sendReportUpload(false, (error as any).messages, this.resolveResult || this.imageBasicInfo, this.uploadResult || {}, false)
      return
    }
  }
  cutString(str: string, length: number) {
    return cutString(str, length);
  }

  pageJumpHandler(data: any) {
    // 加 url编译处理 returnUrl failedReturnUrl + *剩余次数 encodeURIComponent
    // const returnUrl =  data.data ? encodeURIComponent(data.data.returnUrl) : ''
    // const failedReturnUrl =  data.data ? encodeURIComponent(data.data.failedReturnUrl) : ''
    try {
    if (!this.mobileResultPageShow) {
      let url: string = ''
      // code 为成功 且 分数大于50分为检测成功
      if (data.code && data.code === 'SUCCESS' && data.data && data.data.score && data.data.score > 50) {
        const returnUrl = data.data.returnUrl
        if (returnUrl.indexOf('?') !== -1) {
          const queryStr = returnUrl.split('?')[1]
          const isIframe = getQueryString('isLivenessIframe', queryStr)
          if (isIframe && isIframe !== 'false') {
            sendMessage({info: 'successNext'})
            return
          } else {
            url = `${returnUrl}&successCode=${data.code}&version=image`
          }
        } else {
          url = `${returnUrl}?successCode=${data.code}&version=image`
        }
      } else {
        const failedReturnUrl = data.data.failedReturnUrl
        if (failedReturnUrl.indexOf('?') !== -1) {
          const queryStr = failedReturnUrl.split('?')[1]
          const isIframe = getQueryString('isLivenessIframe', queryStr)
          if (isIframe && isIframe !== 'false') {
            sendMessage({info: 'failedNext'})
            return
          } else {
            url = `${failedReturnUrl}&failCode=${data.code || ''}&message=${data.message}&version=image`
          }
        } else {
          url = `${failedReturnUrl}?failCode=${data.code || ''}&message=${data.message}&version=image`
        }
      }
      if (url.length > 0) {
        window.location.href = url
        return
      }
    }
    this.$router.push({
      name: 'ImageResultV2',
      query: {
        result: data.code,
        message: data.message,
        score: data.data ? `${data.data.score}` : '',
        tryCount: data.data ? data.data.tryCount : 0,
        returnUrl: data.data ? encodeURIComponent(data.data.returnUrl) : '',
        failedReturnUrl: data.data ? encodeURIComponent(data.data.failedReturnUrl) : '',
        faceImage: data.data && data.data.imageUrl ? `${data.data.imageUrl}` : '',
      },
    })
    } catch (e) {
      this.$router.push({
        name: 'ImageResultV2',
        query: {
          result: data.code,
          message: data.message,
          score: data.data ? `${data.data.score}` : '',
          tryCount: data.data ? data.data.tryCount : 0,
          returnUrl: data.data ? encodeURIComponent(data.data.returnUrl) : '',
          failedReturnUrl: data.data ? encodeURIComponent(data.data.failedReturnUrl) : '',
          faceImage: data.data && data.data.imageUrl ? `${data.data.imageUrl}` : '',
        },
      })
    }
  }

  overtakeMaximumSizeReject(size: number, fileObjInfo?: IFileObj) {
    return new Promise<void>((resolve, reject) => {
      if (size > MAX_SIZE) {
        // console.warn('file size more than 5M')
        this.loading = false
        this.resolveFailedHint = true
        this.failedCode = 'NONSUPPORT_DEVICE'
        this.failedMessage = this.$t(`home.resolveFailed`)
        this.sendReportResolve(false, 'NONSUPPORT_DEVICE', this.resolveResult || {}, false)
        return
      }
      resolve()
    })
  }

  hideDialogHandler() {
    this.formatNotSupportHint = false
    this.resolveFailedHint = false
    this.unresolvedVideoSizeTooBigHint = false
  }

  mounted() {
    Report.create(ReportType.LoadPage).send()

    this.bizToken = this.$route.query.biz_token
    store.bizToken = this.$route.query.biz_token as string
    this.isConfigCon()
    window.addEventListener('setItem', () => {
      this.isConfigCon()
    })
    if (this.bizToken) {
      this.isAllowUpload = true
      return
    }
  }
  beforeDestroy() {
    window.removeEventListener('setItem', () => {
      console.log('removeSetItem')
    })
  }

  sendReportPreCheck(result: boolean, message: string, fileObj?: IFileObj, isJump?: boolean) {
    const report = getReport()
    const reportDetail = report.info.detail
    reportDetail.state = 'PRE_CHECK'
    reportDetail.result = result
    reportDetail.message = message
    reportDetail.imageFileFullName = fileObj ? fileObj.file.name : ''
    reportDetail.imageOrigFormat = fileObj ? fileObj.file.type : ''
    reportDetail.imageOrigSize = fileObj ? fileObj.file.size : 0
    sendReport(report, message, isJump)

    Report.create(ReportType.CheckImage, reportDetail).send()
  }

  getReportResolve(result: boolean, message: string, resolveResult: IResolveResult, isJump?: boolean) {
    const report = getReport()
    report.eventTimestamp = this.eventTimestamp
    report.takePhotoTimestamp = this.takePhotoTimestamp
    const reportDetail = report.info.detail
    reportDetail.state = 'RESOLVE'
    reportDetail.result = result
    reportDetail.message = message
    reportDetail.imageFileFullName = resolveResult.imageFileFullName
    reportDetail.imageOrigFormat = resolveResult.imageOrigFormat
    reportDetail.imageOrigSize = resolveResult.imageOrigSize
    reportDetail.imageOrigWidth = resolveResult.imageOrigWidth
    reportDetail.imageOrigHeight = resolveResult.imageOrigHeight

    reportDetail.isResolved = resolveResult.isResolved
    reportDetail.resolveTime = resolveResult.resolveTime
    reportDetail.imageResolvedFormat = resolveResult.imageResolvedFormat
    reportDetail.imageResolvedSize = resolveResult.imageResolvedSize
    reportDetail.imageResolvedWidth = resolveResult.imageResolvedWidth
    reportDetail.imageResolvedHeight = resolveResult.imageResolvedHeight
    reportDetail.userId = this.$route.query.userId || ''

    return report
  }

  sendReportResolve(result: boolean, message: string, resolveResult: IResolveResult, isJump?: boolean) {
    let report = this.getReportResolve(result, message, resolveResult, isJump)
    sendReport(report)

    Report.create(ReportType.ResolveImage, report.info.detail).send()
  }

  sendReportUpload(result: boolean, message: string, resolveResult: IResolveResult, uploadResult: IUploadResult, isJump?: boolean) {
    const report = this.getReportResolve(result, message, resolveResult)
    const reportDetail = report.info.detail
    reportDetail.state = 'UPLOAD'
    reportDetail.uploadTime = uploadResult.uploadTime
    reportDetail.transactionId = uploadResult.transactionId
    reportDetail.score = uploadResult.score
    reportDetail.tryCount = uploadResult.tryCount
    reportDetail.returnUrl = uploadResult.returnUrl
    reportDetail.failedReturnUrl = uploadResult.failedReturnUrl
    sendReport(report, message, isJump)

    Report.create(ReportType.UploadImage, reportDetail).send()
  }
}
